<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-subway-map`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 4a1 1 0 011 1v5h18V5a1 1 0 011-1h2a1 1 0 011 1v5h5a1 1 0 011 1v2a1 1 0 01-1 1h-5v20a2 2 0 01-2 2H19.502A6.522 6.522 0 0116 39.503L16 43a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3.174a6.514 6.514 0 01-4.502-3.825L5 36a1 1 0 01-1-1v-2a1 1 0 011-1h2.174A6.51 6.51 0 0112 27.174V14H5a1 1 0 01-1-1v-2a1 1 0 011-1h7V5a1 1 0 011-1h2zm-1.5 27a2.537 2.537 0 00-.362.026l.092-.012c-.06.007-.119.015-.177.026l.085-.014a2.462 2.462 0 00-.225.043l.14-.03c-.058.011-.116.024-.172.038l.032-.008a2.482 2.482 0 00-.442.152l.062-.027c-.06.025-.12.053-.177.082l.115-.055a2.544 2.544 0 00-.152.075l.037-.02a2.477 2.477 0 00-.18.104l.143-.084c-.055.03-.109.061-.162.095l.018-.011c-.054.034-.107.07-.158.107l.14-.096a2.513 2.513 0 00-.88.965l.019-.037a2.525 2.525 0 00-.071.144l.052-.107c-.03.058-.058.117-.083.177l.03-.07c-.06.133-.11.273-.147.417v.004a2.406 2.406 0 00-.051.254l.014-.084c-.01.058-.02.116-.026.176l.012-.092a2.47 2.47 0 00-.02.175L11 33.5a2.5 2.5 0 102.664-2.495L13.5 31zM34 14H16v13.498A6.514 6.514 0 0119.827 32H34V14z"/></svg>
</template>
<script>

export default {
  name: 'IconSubwayMap',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
